module.exports = __webpack_public_path__ + "static/media/Angle's Class II Division I2.802b7169.png";